
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 8a8 8 0 1116 0A8 8 0 010 8zm7.76-1.497l.017.276-.28-.034c-1.018-.13-1.908-.57-2.663-1.31l-.37-.367-.095.27c-.201.605-.072 1.244.347 1.673.224.237.174.271-.212.13-.135-.045-.252-.08-.263-.062-.04.04.095.553.201.757.146.282.442.559.767.723l.274.13-.325.005c-.313 0-.324.006-.29.125.111.367.553.757 1.046.926l.347.119-.302.18a3.15 3.15 0 01-1.5.419c-.252.005-.459.028-.459.045 0 .056.683.373 1.08.497 1.192.367 2.608.21 3.67-.418.756-.446 1.512-1.333 1.864-2.192.19-.458.38-1.294.38-1.695 0-.26.018-.294.33-.604.186-.181.36-.379.393-.435.056-.108.05-.108-.235-.012-.476.17-.543.147-.308-.107.173-.18.38-.508.38-.604 0-.017-.084.01-.179.062-.1.056-.324.141-.492.192l-.302.096-.274-.187a2.278 2.278 0 00-.476-.248 1.909 1.909 0 00-.98.022c-.699.255-1.141.91-1.09 1.628z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    